import LinearProgress from '@mui/material/LinearProgress';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Actions as ADMINACTIONS } from '../../store/actions/adminActions';
import { AddButton, RowBtn } from '../../styledComponents/GlobalStyle';
import { Actions as DASHBOARDACTIONS } from '../../store/actions/dashboardActions';
import { NoPermissions } from '../Common/ReusableComponents/Reusable';
import _ from 'lodash';

const NetZeroRow = ({ target }) => {
  function formatTargetCoverage(arr) {
    if (!Array.isArray(arr)) return '';
    return arr
      .map(
        (item) =>
          item
            .replace(/(\d+)/, ' $1') // Add space before numbers
            .replace(/^./, (c) => c.toUpperCase()) // Capitalize first letter
      )
      .join(', ');
  }

  return (
    <tr>
      <td id='target-name' style={{ textAlign: 'left' }}>
        {formatTargetCoverage(target?.targetCoverage)}
      </td>
      <td>{target?.settingMethod || 'Absolute Contraction'}</td>
      <td>{target?.type}</td>
      <td>{target?.baseYear}</td>
      <td>{target?.targetYear}</td>
      <td>
        <RowBtn className='view-edit-button' id='Target-view-edit' to={`/netZero/${target.id}`}>
          View/Edit
        </RowBtn>
      </td>
    </tr>
  );
};

const NetZeroTable = ({ list, branding, showLoader, adminUser, getTargets, currentOrganisation, netZero }) => {
  const { headers } = branding.fonts?.[0].font || {};
  const { btnTextColor } = branding.colors || {};
  const history = useHistory();

  useEffect(() => {
    if (!list || list?.length < 1) {
      getTargets();
    }
  }, [getTargets, currentOrganisation]);

  if (!netZero) {
    return <NoPermissions />;
  }

  return (
    <div className='row'>
      <div className='col-lg-12'>
        <section className='panel'>
          <header className='panel-heading' style={{ fontFamily: headers }}>
            Science Based Targets
          </header>
          <div className='panel-body'>
            {showLoader ? (
              <LinearProgress sx={{ marginTop: '3vh' }} color='inherit' />
            ) : (
              <>
                <div style={{ overflowX: 'auto' }}>
                  <table className='table table-hover general-table' style={{ fontFamily: headers }}>
                    <thead>
                      <tr>
                        <th>Target Coverage</th>
                        <th>Target Method</th>
                        <th>Target Type</th>
                        <th>Base Year</th>
                        <th>Target Year</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list && list?.length > 0 && list?.map((target, index) => <NetZeroRow key={index} target={target} />)}
                    </tbody>
                  </table>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', flexWrap: 'wrap' }}>
                  <AddButton
                    id='target-add'
                    onClick={() => {
                      history.push('/netZero/new');
                    }}>
                    Add Net-Zero Target
                  </AddButton>
                  <AddButton
                    disabled={true}
                    id='target-add'
                    onClick={() => {
                      history.push('/netZero/new');
                    }}>
                    Add Near-Term Target (Coming Soon)
                  </AddButton>
                </div>
              </>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { ambassadorAdmin, cyfAdmin, whiteLabelAdmin, consultantAdmin } = state?.profile?.details || {};
  const orgDetails = state?.organisation?.details;
  const currentOrganisation = state?.currentOrganisation;
  const adminUser = cyfAdmin || whiteLabelAdmin || consultantAdmin;
  const features = state?.features;
  const availableFeatures = state.organisation?.details?.features;
  const sbtFeature = features?.find((feature) => feature.featureKey === 'SCIENCE_BASED_TARGETS');
  const netZero = availableFeatures?.includes('SCIENCE_BASED_TARGETS') || sbtFeature?.enabledByDefault || false;

  return {
    list: state?.dashboard?.targets,
    branding: state.branding,
    showLoader: state?.showLoader,
    currentOrgDetails: orgDetails,
    currentOrganisation,
    adminUser,
    netZero,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getTargets: () => dispatch(DASHBOARDACTIONS.getTargets()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NetZeroTable);
